import { DatasetDataInfoResponse } from "api/model/dataset/DatasetDataInfoResponse";
import React from "react";
import {
  TimeOptions,
  TimeOptionKeys,
} from "components/basic/dropdowns/time-unit-dropdown/timeUnits";
import { DataTable } from "primereact/datatable";
import { WeatherComponentDatasetProps, WeatherMonitoringProps } from "../charts/interfaces";
import generateColumns from "./GenerateWeatherMonitoringColumns";
import DatasetLineChart from "../charts/dataset-line-chart/DatasetLineChart";
import { getVisibleDatasets } from "./WeatherMonitoringUtils";

const ChartPanel = ({
  datasetsData,
  currentChartData,
  timeInterval,
  startTime,
  endTime,
  isChartVisible,
}: {
  datasetsData: DatasetDataInfoResponse[];
  currentChartData: WeatherMonitoringProps;
  timeInterval: TimeOptionKeys;
  startTime: Date;
  endTime: Date;
  isChartVisible: boolean;
}) => (
  <div className="overflow-x-auto w-max pr-2">
    {isChartVisible && (
      <div>
        <div className="flex flex-row gap-1">
          <div className="flex flex-column gap-2" style={{ marginTop: "2.8rem" }}>
            <div>Temp.</div>
            <div>Hum.</div>
            <div>Prec.</div>
            <div>Wind</div>
            <div>Dir.</div>
          </div>
          {datasetsData && (
            <DataTable value={[{ id: 1 }]} showGridlines size="small">
              {generateColumns(datasetsData, currentChartData, timeInterval, startTime)}
            </DataTable>
          )}
        </div>
        {((currentChartData.temperature?.isVisible && currentChartData.temperature.dataset) ||
          (currentChartData.feelsLikeTemperature?.isVisible &&
            currentChartData.feelsLikeTemperature.dataset)) && (
          <DatasetLineChart
            datasets={getVisibleDatasets(
              ...([currentChartData.temperature, currentChartData.feelsLikeTemperature].filter(
                Boolean
              ) as WeatherComponentDatasetProps[])
            )}
            height={150}
            reportMode
            dateFrom={startTime}
            dateTo={endTime}
            hideRefresh
            timeAxisStepSeconds={TimeOptions[timeInterval].duration.seconds()}
          />
        )}
        {currentChartData.humidity?.isVisible && currentChartData.humidity.dataset && (
          <DatasetLineChart
            datasets={getVisibleDatasets(currentChartData.humidity)}
            height={150}
            reportMode
            dateFrom={startTime}
            dateTo={endTime}
            hideRefresh
            timeAxisStepSeconds={TimeOptions[timeInterval].duration.seconds()}
          />
        )}
        {((currentChartData.windSpeed?.isVisible && currentChartData.windSpeed.dataset) ||
          (currentChartData.gusture?.isVisible && currentChartData.gusture.dataset)) && (
          <DatasetLineChart
            datasets={getVisibleDatasets(
              ...([currentChartData.windSpeed, currentChartData.gusture].filter(
                Boolean
              ) as WeatherComponentDatasetProps[])
            )}
            height={150}
            reportMode
            dateFrom={startTime}
            dateTo={endTime}
            hideRefresh
            timeAxisStepSeconds={TimeOptions[timeInterval].duration.seconds()}
          />
        )}
        {currentChartData.precipitation?.isVisible && currentChartData.precipitation.dataset && (
          <DatasetLineChart
            datasets={getVisibleDatasets(currentChartData.precipitation)}
            height={150}
            reportMode
            dateFrom={startTime}
            dateTo={endTime}
            hideRefresh
            timeAxisStepSeconds={TimeOptions[timeInterval].duration.seconds()}
          />
        )}
      </div>
    )}
  </div>
);

export default ChartPanel;
